import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { requirements } from '@/mocks/applicationData';

export default function RequirementsSection() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('application.requirements.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('application.requirements.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('application.requirements.titleEn')}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('application.requirements.lead')}
          </p>
        </div>

        <div className="border border-background-200/60 bg-background-50">
          {requirements.map((req, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-5 px-6 py-5 ${
                idx < requirements.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/10 flex-shrink-0 mt-0.5">
                <i className={`${req.icon} text-accent-600 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                <span className="text-[13px] text-foreground-400 tracking-[0.08em] font-label whitespace-nowrap flex-shrink-0">
                  {lang === 'en' ? t(`application.req.${idx}.label`) : req.label}
                </span>
                <span className="text-[16px] text-foreground-800 tracking-[0.04em]">
                  {lang === 'en' ? t(`application.req.${idx}.value`) : req.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
